// import VideoModal from '../ModalVideo/VideoModal'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'

const RiskSection = (props) => {
//   const ClickHandler = () => {
//     window.scrollTo(0, 0)
//   }

  return (
    <section id="risk" className={'' + props.hclass}>
      <div className="risk-wrap container">
        <div className="risk-content">
          <div className="content">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              Risk Management & Mitigation
            </h2>
            {/* <h3>CORE VALUES</h3> */}
            <p className="paragraph fade_bottom">
              At Apex company, we recognize that effective risk management is essential to sustaining our operations and achieving our business objectives. Our comperhensive risk management framework includes"
            </p>
            <p className="fade_bottom">
              <b>Innovations of Oil & Gas Industry</b>
            </p>
            <p className="fade_bottom">
              <b>Independent from Potential Production</b>
            </p>
            
          </div>
        </div>
        <div className='image-content'>
          <div className="image">
            
            <div className="image-2 poort-in-right">
              {/* <img className="img-risk" src={abImg2} alt="" /> */}
              <p className="img-risk">
             <b>Risk Identification:</b> Syatematic assessment of potential risks across all operations, including market fluctuations, regulatory changes, operational hazards, and environmental concerns.
            </p>
            <p className="img-risk">
            <b>Risk Assessment:</b> Evaluating the likelihood and impact of identified risks using quantitative and qualitative methods to prioritize our focus on critical areas.
            </p>
           <p className="img-risk">
            <b>Mitigation Strategies:</b> Developing proactive measures to reduce the likelihood of risks materializing and minimizing their impact. This includes investing in advanced technology, implementing safety protocols, and enhancing employee trining programs. 
            </p>
             <p className="img-risk">
                <b>Monitoring and Review:</b> Continuously monitoring the effectiveness of our risk manegement strategies and making adjustments as necessary to adress emerging risks.            </p>
            
            <p className="img-risk">
          <b>Crisis Management Planning:</b> Establishing comperhensive response plans to ensure swift and effective action in the event of a crisis, safeguarding our employee, operations, and reputation.
            </p>
              <p className="img-risk">
         <b>Stakeholder Engagem ent:</b> Actively involving stakeholders-including employees, clients , and community members- in risk management discussions to gather insights and foster a culture of shared responsibility. This collaborative approch enhances our resilience and ensures that we are well-prepared to navigate challenges.
            </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default RiskSection
